export default "__VITE_ASSET__qBQfsFdX__"